export default "__VITE_ASSET__ot6L0GNJ__"